import { put, call, select } from 'redux-saga/effects';
import { makeRequest } from '../../../core/js/sagas/makeRequest';
import { getProductsRoute } from '../../../core/js/utils/apiRoutes';

import {
    getShopTheLookProductsSuccess,
    getShopTheLookProductsError,
    foundRelatedProducts
} from '../actions/shopTheLookActions';

import {
    error as logError
} from '../../../core/js/utils/logger';

import productUtils from '../utils/utils';

import {
    getRelatedProductsByColor,
    getProductInfoForRelatedProducts,
    getRelatedProductIdList
 } from '../utils/shopTheLookUtils';

export function accumulateRelatedProducts(selectedColor, primarySliceItems) {
    const itemsWithRelatedProductsToColor = primarySliceItems.filter((item, index, arr) =>
        item.code === selectedColor && item.productsRelatedToColor.length > 0
    );

    return itemsWithRelatedProductsToColor;
}

export function *accumulateRelatedProductIds(selectedColor, primarySliceItems) {
    const itemsWithRelatedProductsToColor = accumulateRelatedProducts(selectedColor, primarySliceItems);

    if (itemsWithRelatedProductsToColor.length > 0) {
        const foundProductInfo = getProductInfoForRelatedProducts(itemsWithRelatedProductsToColor);

        yield put(foundRelatedProducts(foundProductInfo));

        const productIdList = getRelatedProductIdList(itemsWithRelatedProductsToColor);

        return productIdList;
    }

    return undefined;
}

export function *getProductsRelatedByColorSaga(selectedColor, poolId) {
    let state = yield select();

    try {
        const product = productUtils.getProductForAction(state);
        const primarySliceItems = product.skuInfo.primarySlice.sliceItems;
        const productIdsOfRelatedProducts = yield call(accumulateRelatedProductIds, selectedColor, primarySliceItems);

        if (productIdsOfRelatedProducts && productIdsOfRelatedProducts.length > 0) {
            const route = getProductsRoute(state, '', productIdsOfRelatedProducts, 'productIds', true);

            const relatedProducts = yield call(makeRequest, route);

            state = yield select();

            const tileInfo = _.get(state.product, 'shopTheLook.tileInfo');

            const relatedProductsByColor = getRelatedProductsByColor(relatedProducts.products, tileInfo);

            yield put(getShopTheLookProductsSuccess(relatedProductsByColor));
        } else {
            // eslint-disable-next-line no-undefined
            yield put(getShopTheLookProductsSuccess(undefined));
        }
    } catch (err) {
        logError('Error getting products related by color', err);
        yield put(getShopTheLookProductsError(err));
    }
}
